<template>
  <div style="position: relative">
    <!-- 固定展示最新 OHLC 数据 -->
    <div
        v-if="latestOHLC"
        style="
        position: absolute;
        top: 10px;
        left: 10px;
        background: rgba(0, 0, 0, 0.6);
        padding: 8px 12px;
        border-radius: 6px;
        color: #3eb38e;
        font-size: 10px;
        z-index: 10;
        line-height: 1.6;
      "
    >
      <div>O = {{ latestOHLC.open }}</div>
      <div>H = {{ latestOHLC.high }}</div>
      <div>L = {{ latestOHLC.low }}</div>
      <div>C = {{ latestOHLC.close }}</div>
    </div>

    <div ref="chartContainer" style="width: 100%; height: 310px;"></div>
  </div>
</template>

<script>
import {
  createChart,
  CandlestickSeries
} from 'lightweight-charts';
import axios from 'axios';

export default {
  name: 'KLineChart',
  data() {
    return {
      chart: null,
      candleSeries: null,
      socket: null,
      latestOHLC: null,
    };
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search)
    const symbol = urlParams.get('symbol').toUpperCase()
    this.renderChart();


    if (symbol) {
      console.log('✅ 获取到 symbol:', symbol)
      // 你可以接下来用这个 symbol，比如初始化 WebSocket
      this.loadKlineData(symbol);
      this.initWebSocket(symbol.toLowerCase());
    } else {
      console.error('❌ URL中没有symbol参数')
    }
  },
  beforeDestroy() {
    if (this.socket) {
      this.socket.close();
    }
  },
  methods: {
    async loadKlineData(symbol) {
      // const { data } = await axios.get('https://api.binance.com/api/v3/klines', {
      const { data } = await axios.get('https://api.edxmco.com/api/klines', {
        params: {
          symbol,
          interval: '1m',
          limit: 500,
        },
      });

      const formatted = data.data.map(item => ({
        time: Math.floor(item[0] / 1000), // 秒级 UTC 时间
        open: parseFloat(item[1]),
        high: parseFloat(item[2]),
        low: parseFloat(item[3]),
        close: parseFloat(item[4]),
      }));

      if (this.candleSeries) {
        this.candleSeries.setData(formatted);
        // 设置初始 OHLC
        this.latestOHLC = formatted[formatted.length - 1];
      }
    },

    renderChart() {
      this.chart = createChart(this.$refs.chartContainer, {
        layout: {
          background: {color: '#0F1326'},
          textColor: '#ccc',
          fontSize: 10,
        },
        grid: {
          vertLines: {color: '#333'},
          horzLines: {color: '#333'}
        },
        timeScale: {
          timeVisible: true,
          secondsVisible: true,
          rightOffset: 10,
          fixRightEdge: true,
          barSpacing: 10
        },
        handleScroll: true,
        handleScale: {
          axisPressedMouseMove: false,
          mouseWheel: true,
          pinch: true,
        }
      });

      this.candleSeries = this.chart.addSeries(CandlestickSeries, {
        upColor: '#26a69a',
        downColor: '#ef5350',
        borderVisible: false,
        wickUpColor: '#26a69a',
        wickDownColor: '#ef5350'
      });

      this.chart.timeScale().fitContent();
    },

    initWebSocket(symbol) {
      const wsUrl = `wss://wss.edxmco.com:3031/?symbol=${symbol}`;

      this.socket = new WebSocket(wsUrl);

      this.socket.onopen = () => {
        console.log(`🟢 已连接 WebSocket (${symbol})`);
      };

      this.socket.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);

          if (this.candleSeries && data.time) {
            this.candleSeries.update({
              time: parseInt(data.time),
              open: parseFloat(data.open),
              high: parseFloat(data.high),
              low: parseFloat(data.low),
              close: parseFloat(data.close),
            });

            this.latestOHLC = data;

            // 🔥 发送给父页面（UniApp）
            window.parent.postMessage(
                { type: 'kline-update', payload: data },
                '*'
            );
          }
        } catch (err) {
          console.error('❌ JSON 解析失败:', err);
        }
      };

      this.socket.onerror = (err) => {
        console.error('❌ WebSocket 错误:', err);
      };

      this.socket.onclose = () => {
        console.warn('⚠️ WebSocket 已断开');
      };
    }
  }
};
</script>

<style>
body{
  background-color: #000;
}
</style>
<style scoped>
/* 你可以在这里进一步自定义样式 */
</style>